import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { goddivaInvoiceReportApi, exportInvoiceRowApi, uploadInvoiceToXeroApi } from "../../../../services/report";

export const getPurchaseInvoiceReportData = createAsyncThunk(
    'report/purchase-invoice-report',
    async (data, { dispatch }) => {
        const response = await goddivaInvoiceReportApi(data);
        const responseData = response.response;
        const items = Array.isArray(responseData) ? responseData : (responseData.results || responseData.data || []);
        const count = !Array.isArray(responseData) && responseData.count !== undefined ? responseData.count : items.length;
        dispatch(setTableRowCount(count));
        return items;
    }
);

export const exportInvoiceDetailReport = createAsyncThunk('report/exportInvoiceDetailReport', async (data, { dispatch }) => {
    const response = await exportInvoiceRowApi(data);
    return response;
});

export const handleXeroUpload = createAsyncThunk('report/handleXeroUpload', async (data, { dispatch }) => {
    const response = await uploadInvoiceToXeroApi(data);
    return response;
});

const purchaseInvoiceAdapter = createEntityAdapter({});

export const {
    selectAll: selectpurchaseInvoiceReport,
    selectById: selectpurchaseInvoiceReportById
} = purchaseInvoiceAdapter.getSelectors(
    state => state.report.citygoddessPurchaseReport
);

const purchaseInvoiceReportSlice = createSlice({
    name: 'citygoddessPurchaseReport',
    initialState: purchaseInvoiceAdapter.getInitialState({
        id: null,
        purchaseInvoiceTableRow: 0
    }),

    reducers: {
        setTableRowCount: (state, action) => {
            state.purchaseInvoiceTableRow = action.payload;
        },
    //     setTotalAmount: (state, action) => {
    //         state.totalAmount = action.payload;
    //     },
    },

    extraReducers: {
        [getPurchaseInvoiceReportData.fulfilled]: purchaseInvoiceAdapter.setAll
    }
});

export const { setTableRowCount} = purchaseInvoiceReportSlice.actions;

export default purchaseInvoiceReportSlice.reducer;